// Small browser cache for "show the last data instantly, refresh in the background" (stale-while-revalidate).
// Memory first, then sessionStorage (survives a reload, per tab, gone when the tab closes).
// Keys are scoped to the logged-in token, so another login on the same browser never sees this data;
// AuthContext.logout() also clears everything.

const PREFIX = 'flxc:';
const MAX_ENTRY_BYTES = 512 * 1024; // don't put huge folder listings into sessionStorage
const mem = new Map();

function scope() {
  const tok = localStorage.getItem('token') || '';
  return tok.slice(-12); // last chars of the JWT signature: unique per login, never sent anywhere
}

function fullKey(key) { return `${PREFIX}${scope()}:${key}`; }

/** Cached value or undefined. `maxAgeMs` (optional) ignores older entries. */
export function cacheGet(key, maxAgeMs) {
  const k = fullKey(key);
  let e = mem.get(k);
  if (!e) {
    try { const raw = sessionStorage.getItem(k); if (raw) { e = JSON.parse(raw); mem.set(k, e); } } catch (_) { }
  }
  if (!e) return undefined;
  if (maxAgeMs != null && Date.now() - e.at > maxAgeMs) return undefined;
  return e.data;
}

export function cacheSet(key, data) {
  const k = fullKey(key);
  const e = { at: Date.now(), data };
  mem.set(k, e);
  try {
    const raw = JSON.stringify(e);
    if (raw.length <= MAX_ENTRY_BYTES) sessionStorage.setItem(k, raw);
  } catch (_) { /* storage full / disabled: memory cache still works */ }
}

/** Remove every key starting with `prefix` (e.g. all folders of one server after a write). */
export function cacheDrop(prefix) {
  const p = fullKey(prefix);
  for (const k of [...mem.keys()]) if (k.startsWith(p)) mem.delete(k);
  try {
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const k = sessionStorage.key(i);
      if (k && k.startsWith(p)) sessionStorage.removeItem(k);
    }
  } catch (_) { }
}

/** Everything (logout). */
export function cacheClear() {
  mem.clear();
  try {
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const k = sessionStorage.key(i);
      if (k && k.startsWith(PREFIX)) sessionStorage.removeItem(k);
    }
  } catch (_) { }
}
